import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/catalogos/administracion-plazas-detalles/';

/**
 * GET Detalles de Administración de Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getAdministracionPlazasDetalles = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Detalle Individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAdministracionPlazaDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear Firma/Detalle
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAdministracionPlazaDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Editar Detalle
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAdministracionPlazaDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Eliminar Detalle
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteAdministracionPlazaDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Detalle de Plaza
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarAdministracionPlazaDetalle = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
